import { render } from "./StationInfo.vue?vue&type=template&id=0c2a663c&scoped=true"
import script from "./StationInfo.vue?vue&type=script&lang=js"
export * from "./StationInfo.vue?vue&type=script&lang=js"

import "./StationInfo.vue?vue&type=style&index=0&id=0c2a663c&scoped=true&lang=css"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2a663c"]])

export default __exports__